import { useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { 
    SidePopupContainer, FlexColumn, Button, 
    Form, FormGroup, FlexRow, AppSpan, 
    ReactSelect
} from "src/style"
import { RiCloseFill } from "react-icons/ri"
import { useContext } from "react"
import { components } from "react-select"
import { ReactComponent as InstitutionFillIcon } from 'src/assets/img/institution-fill-icon.svg'
import { availabilityStatus } from 'src/utils/mock-data'
import utility from "src/utils/utility"


export const Add_Edit_Category: React.FC<any> = ({getCategories, rowData, isEdit, close}) => {
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState<any>({name: '', description: '', availabilityStatus: ''})

    const { Option } = components;
    const IconOption = (props: any) => (
        <Option {...props}>
            <InstitutionFillIcon style={{ marginRight: '1.5rem' }} />
            {props.data.label}
        </Option>
    );

    useEffect(() => {
        if (rowData?.name && isEdit) {
            const {name, description, availabilityStatus} = rowData
            setInput({...input, name, description, availabilityStatus})
        }
    }, [rowData])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        const payload: any = {
            ...input,
            availabilityStatus: input.availabilityStatus.value,
        }

        const response = isEdit ? await API.UpdateServiceCategory(rowData?.id, payload)
            : await API.CreateServiceCategory(payload)
        
        if (response) {
            if (getCategories) getCategories()
            close()
        }
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">{isEdit ? 'Edit Category' : 'Create New Category'}</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <FormGroup>
                        <label>Category name</label>
                        <input 
                            placeholder="Enter category name" 
                            name='name'
                            value={input.name}
                            onChange={handleInput}
                            required
                        />
                    </FormGroup>
                        <ReactSelect
                            bottomMargin="2"
                            styles={utility.reactSelectStyles()}
                            options={
                                availabilityStatus?.map((item: any, index: number) => {
                                    return {
                                        label: item.label,
                                        value: item.value,
                                        key: index
                                    }
                                })
                            }
                            isClearable={true}
                            isSearchable={true}
                            name='availabilityStatus'
                            placeholder="Select Availability Status"
                            menuPortalTarget={document.body}
                            value={input.availabilityStatus}
                            onChange={(val) => setInput({ ...input, availabilityStatus: val })}
                            components={{ Option: IconOption }}
                        />    
                    <FormGroup>
                        <label>Description</label>
                        <textarea 
                            placeholder="Enter description" 
                            name='description'
                            value={input.description}
                            onChange={handleInput}
                        />
                    </FormGroup>  
                    
                    <FlexRow justifyContent='flex-end'>
                        <Button
                            width='8.1'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            Submit
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}